/////////////////////////
// tslint:disable-next-line
(global as any).PIXI = require("pixi.js");
import "pixi-spine";
//////////

import { AssetConfigSchema, SpineConfig } from "appworks/config/asset-config-schema";
import { graphicsManager } from "appworks/graphics/graphics-manager";
import { loader } from "appworks/loader/loader";
import { spine, Texture } from "pixi.js";
import { DualPosition } from "../pixi/dual-position";
import { SpineContainer } from "../pixi/spine-container";

import { logger } from "appworks/utils/logger";
import Logger = require("js-logger");

class SpineManager {
    public spineData: Map<string, spine.core.SkeletonData> = new Map<string, spine.core.SkeletonData>();
    public spineConfig: SpineConfig;

    public init(config: AssetConfigSchema) {
        const layoutConfig = config.layouts.all;
        this.spineConfig = layoutConfig.spines;

        this.initAllSpines();

        loader.onStageLoad.add(() => {
            this.initAllSpines();
        });
    }

    public info() {
        let output = "-------- Spine Info --------\n";

        this.spineData.forEach((spineData, index) => {
            output += "--------------------------------\n";
            output += `         ${index}\n`;
            output += "--------------------------------\n";

            output += "\nAnimations:\n";
            spineData.animations.forEach((animation) => {
                const duration = Math.floor(animation.duration * 1000);
                output += "\t" + animation.name + " [" + duration + "]\n";
            });

            output += "\nEvents:\n";
            spineData.events.forEach((event) => {
                output += "\t" + event.name + "\n";
            });
        });

        Logger.info(output);
    }

    public extractFirstFrames() {
        Logger.info("-------- Spine First Frames --------\n");

        const elements = [];

        this.spineData.forEach((spineData, index) => {
            const spine = this.createSpine(index);
            const imgEl = PIXI.autoDetectRenderer().extract.image(spine);

            imgEl.id = index;
            elements.push(imgEl);

            spine.destroy();
        });

        document.body.innerHTML = "";
        elements.forEach((element) => {
            const title = document.createElement("div");
            title.innerText = element.id;
            document.body.appendChild(title);
            document.body.appendChild(element);
        });
        document.body.style.setProperty("overflow", "scroll", "important");
        document.body.style.setProperty("background-color", "#ffffff", "important");
        document.body.style.setProperty("font-size", "50px", "important");
        document.body.style.setProperty("color", "#000000", "important");
    }

    public update(time: number) {
        //
    }

    public createSpineContainer(name: string | string[], position: DualPosition): SpineContainer | undefined {
        const spineAnim = this.createSpine(name);
        if (spineAnim) {
            const container = new SpineContainer(spineAnim.name, position);
            container.landscape.x = position.landscape.x;
            container.landscape.y = position.landscape.y;
            container.portrait.x = position.portrait.x;
            container.portrait.y = position.portrait.y;
            container.setupSpine();
            return container;
        } else {
            return undefined;
        }
    }

    public createSpine(name: string | string[]): spine.Spine | undefined {
        if (typeof (name) === "string") {
            if (!this.spineData.get(name)) {
                throw new Error("Spine `" + name + "` does not exist in spine cache");
            }

            const spineData = this.spineData.get(name);
            const spineObj = new spine.Spine(spineData);
            spineObj.name = name;
            return spineObj;
        } else {
            for (const entry of name) {
                if (this.spineData.has(entry)) {
                    const spineData = this.spineData.get(entry);
                    const spineObj = new spine.Spine(spineData);
                    spineObj.name = entry;
                    return spineObj;
                }
            }

            return undefined;
        }
    }

    private initAllSpines() {
        for (const name in this.spineConfig) {
            if (this.spineConfig.hasOwnProperty(name)) {
                const spineJSON = this.spineConfig[name];
                if (this.spineData.get(name) === undefined) {
                    try {
                        this.spineData.set(name, this.generateSpineData(name, spineJSON));
                    } catch (e) {
                        (window as any).testms = () => loader.allStagesLoaded();
                        if (loader.allStagesLoaded()) {
                            logger.error(e);
                        } else {
                            continue;
                        }
                    }
                }
            }
        }
    }

    private generateSpineData(name: string, spineJSON: any) {
        const spineAtlas = this.generateSpineAtlas(name, spineJSON);

        const spineAtlasLoader = new spine.core.AtlasAttachmentLoader(spineAtlas);
        const spineJsonParser = new spine.core.SkeletonJson(spineAtlasLoader);

        return spineJsonParser.readSkeletonData(spineJSON);
    }

    private generateSpineAtlas(name: string, spineData: any) {
        const spineAtlas = new spine.core.TextureAtlas();
        const allTextures: { [key: string]: Texture } = {};

        const skins = spineData.skins;

        for (const skin of skins) {
            for (const attachmentKey in skin.attachments) {
                if (skin.attachments.hasOwnProperty(attachmentKey)) {
                    const slots = skin.attachments[attachmentKey];
                    for (const slotKey in slots) {

                        if (slots.hasOwnProperty(slotKey)) {
                            const slot = slots[slotKey];
                            const textureId = slot.name || slot.path || slotKey;
                            const textureName = name + "/" + (textureId);
                            const altTextureName = name + "/images/" + (textureId);

                            let texture: Texture;
                            if (graphicsManager.hasTexture(textureName)) {
                                texture = graphicsManager.getTexture(textureName);
                            }
                            if (graphicsManager.hasTexture(altTextureName)) {
                                texture = graphicsManager.getTexture(altTextureName);
                            }

                            if (texture) {
                                allTextures[textureId] = texture;
                            }
                        }
                    }
                }
            }
        }

        spineAtlas.addTextureHash(allTextures, true);

        return spineAtlas;
    }
}

export const spineManager = new SpineManager();
